(function () {
    const head = document.getElementById('gh-head');
    if (!head) return;

    // 1100px, not 991px -- matches screen.css's own nav breakpoint (moved
    // since the 10-category desktop row wraps to 2 lines at ≤1075px, e.g.
    // iPad Pro portrait's 1024px).
    const isMobileMenu = window.matchMedia('(max-width: 1100px)');
    const backButton = head.querySelector('.nav-mobile-back');
    const items = head.querySelectorAll('.aleph-nav > .nav-item');

    // Guards against a "reflow click-through": swapping screens changes
    // what's rendered at the tap's coordinates, and on some touch
    // browsers the tap's synthetic click event can resolve against the
    // layout AFTER that swap rather than before, landing on whichever
    // link now sits under the finger (already seen with the accordion
    // variant of this menu -- see the session log). Freezing the
    // freshly-shown screen's pointer-events for a short window swallows
    // that stray click regardless of which browser mechanism causes it.
    const freeze = function (el) {
        if (!el) return;
        el.style.pointerEvents = 'none';
        setTimeout(function () {
            el.style.pointerEvents = '';
        }, 400);
    };

    const closeSubmenu = function () {
        document.body.classList.remove('mobile-submenu-open');
        items.forEach(function (item) {
            item.classList.remove('is-submenu-open');
        });
    };

    items.forEach(function (item) {
        const dropdown = item.querySelector(':scope > .nav-dropdown');
        if (!dropdown) return; // no subcategories -- let the link navigate normally

        const link = item.querySelector(':scope > a');
        link.addEventListener('click', function (e) {
            // Checked directly against viewport width rather than the
            // burger's gh-head-open class -- that class is toggled by a
            // separate jQuery-bound handler and shouldn't be a
            // dependency for this to work reliably.
            if (!isMobileMenu.matches) return;

            e.preventDefault();
            item.classList.add('is-submenu-open');
            document.body.classList.add('mobile-submenu-open');
            freeze(dropdown);
        });
    });

    if (backButton) {
        backButton.addEventListener('click', function () {
            closeSubmenu();
            const nav = head.querySelector('.aleph-nav');
            freeze(nav);
        });
    }

    // Always land back on the top-level list when the burger is toggled,
    // so the menu never reopens mid-drilldown.
    const burger = document.querySelector('.gh-burger');
    if (burger) {
        burger.addEventListener('click', closeSubmenu);
    }
})();
